import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Row, Col, Icon } from 'shpmtcd'
import Logo from './Logo'
import Profile from '../container/Profile'

const theme = (merchant) => ({
  backgroundColor: `${merchant.theme_settings ? merchant.theme_settings.header_background : ''}`,
  color: `${merchant.theme_settings ? merchant.theme_settings.header_color : ''}`,
})

class Header extends Component {
  render() {
    const {
      merchant, redirectUrl, userName, location,
    } = this.props
    const { pathname } = location

    const favicon = document.getElementById('Favicon')
    favicon.href = merchant.logo_url || './logo.ico'

    const title = document.getElementById('merchant-store-title')
    title.innerHTML = `${merchant.canonical_name} - My Account`

    return (
      <div className='top-bar' style={theme(merchant)}>
        <Row
          gutter={20}
          className='top-bar-content-wrapper shpmtcd'
        >
          <Col className='Logo-wrapper'>
            <a href={`${window.location.origin}/`} id='continueShopping-small-screen'>
              <Icon type='shpmtcdicon-arrow-left-thin' />
            </a>
            <Logo
              redirectUrl={redirectUrl}
              logoURL={merchant.logo_url}
              canonicalName={merchant.canonical_name}
            />
          </Col>
          <Col className='nav-right'>
            {
              pathname !== '/signin'
                ? <Profile name={userName} color={theme(merchant).color} />
                : null
            }
          </Col>
        </Row>
      </div>
    )
  }
}

Header.propTypes = {
  merchant: PropTypes.shape({
    logo_url: PropTypes.string,
    canonical_name: PropTypes.string,
  }).isRequired,
  userName: PropTypes.string.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
  redirectUrl: PropTypes.string,
}

Header.defaultProps = {
  redirectUrl: '',
}

export default Header
